import React, { Component } from "react"
import { connect } from "react-redux"

import {
  Segment,
  Grid,
  Image,
  Header,
  Icon,
  Modal,
  Button,
  Container,
  Item,
  Divider
} from "semantic-ui-react"
import "./LandingPageComponent.css"
import CarouselLanding from "./CarouselLanding"

const mapStateToProps = state => ({
  app: state.app
})

class ConnectedLandingPageComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let { t } = this.props
    return (
      <Segment id="mainLandingPage">
        <CarouselLanding />
      </Segment>
    )
  }
}

const LandingPageComponent = connect(mapStateToProps)(
  ConnectedLandingPageComponent
)
export default LandingPageComponent



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/LandingPageComponent.js